import React from "react";

export default function BotonRegresar({ onClick }) {
  return (
    <div className="center-align">
      <button
        className="btn pink accent-2 z-depth-1"
        style={{
          borderRadius: "30px",
          padding: "0 2rem",
          fontWeight: "600",
        }}
        onClick={onClick}
      >
        Regresar
      </button>
    </div>
  );
}
